import type { RecommendationDeleteButtonProps } from "./recommendation-delete-button.type";

import DeleteButton from "@/components/Header/Button/DeleteButton";
import { BUTTON_TYPE, BUTTON_KEYS } from "@/constants/Button";

const RecommendationDeleteButton = ({
  interventionId,
  recommendation,
  disabled,
}: RecommendationDeleteButtonProps) => {
  return (
    <DeleteButton
      key={BUTTON_KEYS.DELETE}
      model={recommendation}
      modelKey="recommendation"
      invalidateKeys={[
        ["observations"],
        ["interventions"],
        ["recommendations"],
      ]}
      isIconButton
      rootId={interventionId}
      buttonProps={{
        disabled,
        type: BUTTON_TYPE.DEFAULT,
        shape: "default",
      }}
    />
  );
};

export default RecommendationDeleteButton;
